module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/suns_footer_image_03-807873d1e4c543089e19545a5adad605.jpg";